import ApiService from './api.service'

const NodeService = {
    get(сompanyId, companyName, addressSearchString, typeId, clientName, personalAccount, meterSerialNumber, transportSerialNumber, projectId, taskId, projectName, notInProjectId, notInTaskId, withCoordinates, withStatements, isDeleted, showWarnings, showErrors, sortColumns, page, count) {
        return ApiService.get('api/nodes', {
            params: {
                CompanyId: сompanyId,
                CompanyName: companyName,
                AddressSearchString: addressSearchString,
                TypeId: typeId,
                ClientName: clientName,
                PersonalAccount: personalAccount,
                MeterSerialNumber: meterSerialNumber,
                TransportSerialNumber: transportSerialNumber,
                ProjectId: projectId,
                TaskId: taskId,
                ProjectName: projectName,
                NotInProjectId: notInProjectId,                
                NotInTaskId: notInTaskId,
                WithCoordinates: withCoordinates,
                WithStatements: withStatements,
                IsDeleted: isDeleted,
                ShowWarnings: showWarnings,
                ShowErrors: showErrors,
                SortColumns: sortColumns,
                Page: page,
                Count: count
            }
        })
    },

    getById(id) {
        return ApiService.get('api/nodes/'+id)
    },

    create(idCompany, idType, clientName, personalAccount, contractColdWater, contractHeat, contractElectricity, contractGas, additionalInfo, phoneNumber, idSprAddress, homeNumber, idSprAddressTypeHome, apartmentNumber, idSprAddressTypeApartment, latitude, longitude) {
      let node = {
        idCompany: idCompany,
        idType: idType,
        clientName: clientName,
        personalAccount: personalAccount,
        contractColdWater: contractColdWater,
        contractHeat: contractHeat,
        contractElectricity: contractElectricity,
        contractGas: contractGas,
        additionalInfo: additionalInfo,
        phoneNumber: phoneNumber,
        idSprAddress: idSprAddress,
        homeNumber: homeNumber,
        idSprAddressTypeHome: idSprAddressTypeHome,
        apartmentNumber: apartmentNumber,
        idSprAddressTypeApartment: idSprAddressTypeApartment,
        latitude: latitude,
        longitude: longitude
        
      }
      return ApiService.post(`/api/nodes`, node)
    },

    update(id, idType, clientName, personalAccount, contractColdWater, contractHeat, contractElectricity, contractGas, additionalInfo, phoneNumber, idSprAddress, homeNumber, idSprAddressTypeHome, apartmentNumber, idSprAddressTypeApartment, latitude, longitude) {
      let node = {
        id: id,
        idType: idType,
        clientName: clientName,
        personalAccount: personalAccount,
        contractColdWater: contractColdWater,
        contractHeat: contractHeat,
        contractElectricity: contractElectricity,
        contractGas: contractGas,
        additionalInfo: additionalInfo,
        phoneNumber: phoneNumber,
        idSprAddress: idSprAddress,
        homeNumber: homeNumber,
        idSprAddressTypeHome: idSprAddressTypeHome,
        apartmentNumber: apartmentNumber,
        idSprAddressTypeApartment: idSprAddressTypeApartment,
        latitude: latitude,
        longitude: longitude
      }
      return ApiService.put(`/api/nodes`, node)
    },

    archive(id) {
      return ApiService.put(`/api/nodes/archive/${id}`)
    },

    restore(id) {
      return ApiService.put(`/api/nodes/restore/${id}`)
    },

    delete(id) {
      return ApiService.delete(`/api/nodes/${id}`)
    },

    getTypes() {
        return ApiService.get('/api/nodes/types')
    },
    
    getTypeStatistic() {
        return ApiService.get('/api/nodes/types/statistic')
    }
}

export default NodeService